import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { style: {"vertical-align":"middle"} }
const _hoisted_5 = { class: "list-group list-group-flush" }
const _hoisted_6 = {
  key: 0,
  class: "nav-link-icon d-md-none d-lg-inline-block",
  style: {"vertical-align":"middle"}
}
const _hoisted_7 = { style: {"vertical-align":"middle"} }

import {
  NavigationGroup,
  userShouldSeeItem,
} from "@/shared/services/navigation";
import MaterialIcon from "@/shared/components/utils/MaterialIcon.vue";

interface PropsInterface {
  group: NavigationGroup;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavGroupCard',
  props: {
    group: null
  },
  setup(__props: any) {

const props = __props as {
  group: NavigationGroup;
};



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.group.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.group.items, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.title
        }, [
          (_unref(userShouldSeeItem)(item))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: _normalizeClass(["list-group-item list-group-item-action", { disabled: !item.link }]),
                to: { name: item.link }
              }, {
                default: _withCtx(() => [
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createVNode(MaterialIcon, {
                          name: item.icon
                        }, null, 8, ["name"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})